import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import useNext from "./useNext";

const Errors = dynamic(() => import("../Errors"), {
  suspense: true,
});

interface NextProps {
  onNext: (email: string) => void;
  onLogin: () => void;
}

const Next: React.FC<NextProps> = ({ onNext, onLogin }) => {
  const { handleSubmit, onSubmit, errors, isDirty, register } = useNext(onNext);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center flex flex-col gap-2 pb-5">
        <h4 className="text-2xl">Create a Free Account</h4>
        <div>
          <p className="text-base">
            Signup with Your Email or{" "}
            <span>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onLogin();
                }}
                className="text-blue-600 underline"
              >
                Log in
              </button>
            </span>
          </p>
        </div>
      </div>
      {Object.values(errors).length !== 0 && (
        <Suspense
          fallback={
            <>
              <p>Loading...</p>
            </>
          }
        >
          <Errors errors={Object.values(errors)} />
        </Suspense>
      )}
      <div>
        <div className="py-5">
          <input
            {...register("email")}
            className="border border-primary outline-none px-3 py-2 w-full"
            type="email"
            required
            placeholder="Email Address"
          />
        </div>
        <div>
          <button
            disabled={!isDirty}
            className="w-full px-6 py-2 bg-primary text-white"
          >
            Next
          </button>
        </div>
      </div>
    </form>
  );
};

export default Next;
